function dateConverter(date){
    const toDate = date
    const [day, month, year] = toDate.split('/');
    const dateFormat = new Date(+year, month - 1, +day);
    return dateFormat;
}
export {dateConverter}